module.exports = __webpack_public_path__ + "img/environment1.6d8d2ad4.png";